export default __webpack_public_path__ + "static/media/egiro_step_1.7ec0496f.png";